module.exports = __webpack_public_path__ + "static/pic01.55e1797f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic01.jpg
// module id = 30
// module chunks = 122212659448958 123315765418214 212839066777427